module.exports = __webpack_public_path__ + "img/57.e4c1b52f.png";